import {useEffect, useRef, useState} from "react";
import dsStyles from "../styles/index.css";
import cx from "./cx";

const useAnimationOnClick = (opts: {disabled?: boolean; onClick?: () => void}) => {
  const {disabled, onClick} = opts;
  const [animClass, setAnimClass] = useState<null | string>(null);

  const pendingClickRef = useRef<{
    cb?: () => void;
    timeoutId: ReturnType<typeof setTimeout>;
  } | null>(null);

  const handleClick = () => {
    if (!disabled) {
      setAnimClass(dsStyles.animPillActive);
      const timeoutId = setTimeout(() => {
        setAnimClass(cx(dsStyles.animPillActive, dsStyles.disappearAnimPillActive));
        pendingClickRef.current!.timeoutId = setTimeout(() => {
          setAnimClass(null);
          pendingClickRef.current = null;
          onClick?.();
        }, 250);
      }, 250);
      pendingClickRef.current = {timeoutId, cb: onClick};
    } else {
      onClick?.();
    }
  };

  // if we got unmounted during animation, make sure the click handler is still applied
  useEffect(() => {
    return () => {
      const pending = pendingClickRef.current;
      if (pending) {
        clearTimeout(pending.timeoutId);
        pending.cb?.();
      }
    };
  }, []);
  return {onClick: handleClick, animClass};
};

export default useAnimationOnClick;
